// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
  getDocumentChecklists, CalculateFees, ProceedToPay, 
  checkSOA, CheckMainSubmissionDone, GetLatestSoa, GetCaseCode,
  GetPaymentAndFeeDetails
} from '@api';

export const getDocChecklistsFromSubmissionPage = createAsyncThunk('docchecklist/getDocumentChecklists', async args => {
  const response = await getDocumentChecklists(args);
  return response.data;
})

export const calculateFees = createAsyncThunk('payment/calculate_fees', async args => {
  const response = await CalculateFees(args);
  return response.data;
})

export const proceedToPay = createAsyncThunk('payment/proceed_to_pay', async args => {
  const response = await ProceedToPay(args);
  return response.data;
})

export const checkMainSubmissionDone = createAsyncThunk('payment/check_mainsubmission_done', async args => {
  const response = await CheckMainSubmissionDone(args);
  return response.data;
})


export const checkSOAExist = createAsyncThunk('scheduleofassets/checkSOA', async args => {
  const response = await checkSOA(args);
  return response.data;
})

export const getLatestSoa = createAsyncThunk('payment/get_latest_soa_submission', async args => {
  const response = await GetLatestSoa(args);
  return response.data;
})

export const getCaseCodeFromSubmissionPage = createAsyncThunk('landing/get_casecode', async args => {
  const response = await GetCaseCode();
  return response.data;
})

export const getPaymentFeeDetailsSubmission = createAsyncThunk('payment/get_payment_fee_details_submission', async args => { 
  const response = await GetPaymentAndFeeDetails(args); 
  return response.data;
})

export const submissionSlice = createSlice({
    name: 'submission',
    initialState: {
      documents: [],
      depositAmount: (0.00).toFixed(2),
      withSOAFee:(0.00).toFixed(2),
      woSOAFee:(0.00).toFixed(2),
      SOAisExist: false,
      SOAisSubmitted: false,
      latestSoaStatus: "",
      totalPayable:(0.00).toFixed(2),
      submissionGroupid: "",
      isPaid: false,
      startVisitDate:"",
      endVisitDate:"",
      accessCode:"",
      isMainSubmissionPaymentProcessing: false
    },
    reducers:{},
    extraReducers: builder => {
      builder
      .addCase(getDocChecklistsFromSubmissionPage.fulfilled, (state, action) => {
        state.documents = action.payload.documents;
      })
      .addCase(checkSOAExist.fulfilled, (state, action) => {
        state.SOAisExist = action.payload.isSoaExist;
        state.SOAisSubmitted = action.payload.isSoaSubmitted;
      })
      .addCase(calculateFees.fulfilled, (state, action) => {
        state.withSOAFee = action.payload.TotalPayable.toFixed(2);
        state.woSOAFee  = action.payload.TotalPayable.toFixed(2);
        state.totalPayable = action.payload.TotalPayable.toFixed(2);
        state.submissionGroupid = action.payload.SubmissionGroupId;
      })
      .addCase(checkMainSubmissionDone.fulfilled, (state, action) => {
        state.isPaid = action.payload.isPaid;
        state.totalPayable = action.payload.paidAmount.toFixed(2);
        state.startVisitDate = action.payload.startVisitDate;
        state.endVisitDate = action.payload.endVisitDate;
        state.isMainSubmissionPaymentProcessing = action.payload.isMainSubmissionPaymentProcessing;
      })
      .addCase(getLatestSoa.fulfilled, (state, action) => {
        /**
         * New - Next btn disabled, only enabled when checkbox is ticked in Presubmission
         * Pending - Always disabled Next btn
         * Accepted/Rejected - Always enabled Next btn
         */
        if (action.payload)
          state.latestSoaStatus = action.payload.status;
        else 
          state.latestSoaStatus = "";  
      })
      .addCase(getCaseCodeFromSubmissionPage.fulfilled, (state, action) => {
        state.accessCode = action.payload.code;
      })  
    }

})

//export const {} = eligibilityCheckSlice.actions

export default submissionSlice.reducer